import {
  Component,
  OnInit,
  Inject,
  ChangeDetectionStrategy
} from '@angular/core';
import { ItemModel } from 'src/app/items/item.model';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-client-pre-qualifications-items-notes',
  templateUrl: './client-pre-qualifications-items-notes.component.html',
  styleUrls: ['./client-pre-qualifications-items-notes.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ClientPreQualificationsItemsNotesComponent implements OnInit {
  item: ItemModel;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { item: ItemModel },
    private dialogRef: MatDialogRef<ClientPreQualificationsItemsNotesComponent>
  ) {}

  ngOnInit() {
    this.item = this.data.item;
  }

  onSaveAndClose() {
    this.dialogRef.close(this.item.pivot.notes);
  }
}
